import React from "react";
import { AgGridReact } from 'ag-grid-react';
import styled from "styled-components";
import i18next from "i18next";

const ParentProductsGrid = ({ className, data }) => {
  const columnDefs = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'size',
      headerName: 'Size',
      flex: 0.6,
      minWidth: 80,
    },
    {
      field: 'sku',
      headerName: 'SKU',
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'color',
      headerName: i18next.t('productModal.colour'),
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'attributes',
      headerName: 'Attributes',
      flex: 0.8,
      minWidth: 100,
      valueFormatter: (params) => params.value || '-'
    },
  ];

  const defaultColDef = {
    sortable: true,
    filter: false,
    resizable: true,
  };

  if (!data || data.length === 0) {
    return <p className="text-center text-muted">{i18next.t('sparePart.modal.noProducts')}</p>;
  }

  return (
    <div className={className}>
      <AgGridReact
        rowData={data}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        domLayout='autoHeight'
        rowHeight={35}
        headerHeight={38}
        suppressRowClickSelection={true}
        enableCellTextSelection={true}
      />
    </div>
  );
};

const StyledParentProductsGrid = styled(ParentProductsGrid)`
  width: 100%;

  .ag-root-wrapper {
    border: 1px solid #e8eaed;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .ag-root.ag-layout-auto-height {
    border: none;
    padding: 10px;
  }

  .ag-header {
    background-color: #fafafa;
    font-weight: 500;
    border-bottom: 1px solid #e5e7eb;
    
    .ag-header-cell {
      padding: 12px 16px;
      font-size: 0.75rem;
      color: #5f6368;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 500;
    }

    .ag-header-cell:not(.ag-header-cell-auto-height) .ag-header-cell-comp-wrapper {
      height: auto !important;
    }
  }

  .ag-header-cell,
  .ag-cell {
    border-right: 1px solid #f0f0f0;
  }

  .ag-header-cell:last-child,
  .ag-cell:last-child {
    border-right: none;
  }

  .ag-cell {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    font-size: 0.8125rem;
    color: #3c4043;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ag-row {
    border-bottom: 1px solid #f5f5f5;
    transition: background-color 0.12s ease;
  }

  .ag-row:last-child {
    border-bottom: none;
  }

  .ag-row-even {
    background-color: #ffffff;
  }

  .ag-row-odd {
    background-color: #fafafa;
  }

  .ag-row:hover {
    background-color: #f5f5f5 !important;
  }
`;

export default React.memo(StyledParentProductsGrid);